// Проверка аутентификации
export const CHECK_AUTH = "CHECK_AUTH";

// Проверяем, зарегистрирован номер или нет.
export const CHECK_REGISTERED = "CHECK_REGISTERED";

// Генерация проверочного кода
export const LOGIN_CONFIRMATION_CODE = "LOGIN_CONFIRMATION_CODE";

// Выход из системы
export const LOGOUT = "LOGOUT";
